import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetCurrentUserQuery } from '@app/store/slices/users/usersApi';

export function useSyncUserLanguage() {
  const { data: user } = useGetCurrentUserQuery();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (user?.language) {
      void i18n.changeLanguage(user.language);
    }
  }, [user?.language]);
}
